app.ApplicantSearch = (
    function () {
        var search = {
            //Global to page to remember if it was a mobile view to start, since in theory someone can make a screen smaller/larger
            IsMobile: false,
            //Index Page
            Index: function () {
                $(document).on("component-bind-view-mode-complete", function () {
                    app.ApplicantSearch.Init();
                    //We need to tell the comments code that the data has loaded in order fo the comment modal to work on this page
                    $(document).trigger("bind-comments-modal");

                });
            },
            Init: function () {
                app.ApplicantSearch.IsMobile = $(window).width() <= 768;
                //when clicking a checkbox
                $("[name='HideApplicantDistrict']").on("change",
                    function () {
                        var isChecked = $(this).is(":checked");

                        app.ApplicantSearch.ChangeHideText(isChecked);

                        var userId;
                        //ifMobile
                        if (app.ApplicantSearch.IsMobile) {
                            userId = $(this).data("user-id");
                        }
                        //if not Mobile
                        else {
                            userId = $(this).closest("[data-label='HideApplicantDistrict']").siblings("[data-label='Id']").find("[name='Id']").val();
                        }

                        $("#UserId").val(userId);
                        $("#OriginalStateDistrict").val(!isChecked);
                        $("#confirmDistrict").modal({show:true, backdrop: 'static', keyboard: false });
                    });

                //When submitting from the modal
                $("[data-submit-action='district']").off().on("click",
                    function () {

                        //build object
                        var data = {
                            userId: $("#UserId").val(),
                            isHidden: $("#OriginalStateDistrict").val() != "true"
                        };

                        //submit to endpoint
                        $.post("/Employer/ApplicantSearch/ChangeDistrictApplicantHideForView", data,
                            function () {
                                //on successful district hide, mark all of the user's apps as user district hidden
                                if (app.ApplicantSearch.IsMobile) {
                                    $("input[data-user-id='" + $("#UserId").val() + "']").each(function (i, e) {
                                        $(e).prop("checked", $("#OriginalStateDistrict").val() !== "true");
                                    });
                                } else {
                                    $("input[name='Id']").each(function (i, e) {
                                        if ($(e).val() == $("#UserId").val()) {
                                            $(e).closest("[data-label='Id']")
                                                .siblings("[data-label='HideApplicantDistrict']")
                                                .find("[type='checkbox']").prop("checked",
                                                    $("#OriginalStateDistrict").val() !== "true");
                                        }
                                    });
                                }
                                toastr.success("You successfully updated the applicant visibility status for the district.", "Success");
                            })
                            .fail(function () {
                                app.ApplicantSearch.ResetDistrictHideCheckboxes();
                                toastr.error("There was an error and the update was not made.", "Error");
                            })
                            .always(function () {
                                $("#confirmDistrict").modal("hide");
                            });
                    });


                //when clicking a checkbox
                $("[name='HideApplicantVacancy']").on("change",
                    function () {

                        var isChecked = $(this).is(":checked");

                        app.ApplicantSearch.ChangeHideText(isChecked);

                        var appId;
                        if (app.ApplicantSearch.IsMobile) {
                            appId = $(this).data("app-id");
                        } else {

                            appId = $(this).closest("[data-label='HideApplicantVacancy']")
                                .siblings("[data-label='ApplicationId']").find("[name='ApplicationId']").val();
                        }

                        $("#ApplicationId").val(appId);
                        $("#OriginalStateVacancy").val(!isChecked);

                        $("#confirmVacancy").modal({ show: true, backdrop: 'static', keyboard: false });
                    });

                $("[data-submit-action='vacancy']").off().on("click",
                    function () {

                        var data = {
                            applicationId: $("#ApplicationId").val(),
                            isHidden: $("#OriginalStateVacancy").val() != "true"
                        };

                        $.post("/Employer/ApplicantSearch/ChangeApplicationHideForView", data, function () {
                            toastr.success("You successfully updated the applicant visibility status for the vacancy.", "Success");
                        })
                            .fail(function () {
                                app.ApplicantSearch.ResetVacancyHideCheckboxes();
                                toastr.error("There was an error and the update was not made.", "Error");
                            })
                            .always(function () {
                                $("#confirmVacancy").modal("hide");
                            });
                    });
            },
            CancelDistrictHide: function () {
                app.ApplicantSearch.ResetDistrictHideCheckboxes();
                toastr.error("You successfully canceled the change.", "Action Canceled");
            },
            CancelVacancyHide: function () {
                app.ApplicantSearch.ResetVacancyHideCheckboxes();
                toastr.error("You successfully canceled the change.", "Action Canceled");
            },
            ChangeHideText: function (isChecked) {
                if (isChecked) {
                    $(".hideText").text("hide");
                } else {
                    $(".hideText").text("unhide");
                }
            },
            ResetVacancyHideCheckboxes: function () {

                if (app.ApplicantSearch.IsMobile) {
                    $("input[data-app-id='" + $("#ApplicationId").val() + "']").each(function (i, e) {
                        $(e).prop("checked", $("#OriginalStateVacancy").val() === "true");
                    });
                } else {

                    $("input[name='ApplicationId']").each(function (i, e) {
                        if ($(e).val() == $("#ApplicationId").val()) {
                            $(e).closest("[data-label='ApplicationId']").siblings("[data-label='HideApplicantVacancy']")
                                .find("[type='checkbox']").prop("checked", $("#OriginalStateVacancy").val() === "true");
                        }
                    });
                }
            },
            ResetDistrictHideCheckboxes: function () {
                if (app.ApplicantSearch.IsMobile) {
                    $("input[data-user-id='" + $("#UserId").val() + "']").each(function (i, e) {
                        $(e).prop("checked", $("#OriginalStateDistrict").val() === "true");
                    });
                } else {

                    $("input[name='Id']").each(function (i, e) {
                        if ($(e).val() == $("#UserId").val()) {
                            $(e).closest("[data-label='Id']").siblings("[data-label='HideApplicantDistrict']")
                                .find("[type='checkbox']")
                                .prop("checked", $("#OriginalStateDistrict").val() === "true");
                        }
                    });
                }
            }
        };

        return search;

    }()
);